import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

export const fireToolbarButtonAnalyticsEvent = (
	sourceNode: any,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
): void => {
	if (!createAnalyticsEvent) {
		return;
	}

	const sourceAttributes = {
		sourceNodeType: sourceNode.type,
	};

	// Source is Connect macro
	if (
		sourceNode.type === 'extension' &&
		sourceNode.attrs?.extensionType === 'com.atlassian.confluence.macro.core'
	) {
		Object.assign(sourceAttributes, {
			sourceExtensionType: sourceNode.attrs?.extensionType,
			sourceExtensionKey: sourceNode.attrs?.extensionKey,
			sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
			sourceExtensionParameters: sourceNode.attrs?.parameters,
		});
	}

	const analyticsData = {
		type: 'sendUIEvent',
		data: {
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'createReference',
			source: 'editorFloatingToolbar',
			attributes: {
				...sourceAttributes,
				targetNodeType: 'extension',
				targetExtensionType: 'com.atlassian.chart',
				targetExtensionKey: 'chart:default',
			},
		},
	};
	createAnalyticsEvent(analyticsData).fire();
};
